module.exports = __webpack_public_path__ + "static/media/backend-technologies.1a4a2980.svg";